import { FormEvent, useState } from 'react';
import type { Integration } from '../../types/api';
import { Form, Button } from '../ui';
import GeneralTab from './tabs/GeneralTab';
import IxcTab from './tabs/IxcTab';
import WhaticketTab from './tabs/WhaticketTab';
import GammuTab from './tabs/GammuTab';
import DigisacTab from './tabs/DigisacTab';
import SgpTab from './tabs/SgpTab';
import HubsoftTab from './tabs/HubsoftTab';
import MediawikiTab from './tabs/MediawikiTab';
import OpaTab from './tabs/OpaTab';
import ForticsTab from './tabs/ForticsTab';
import AsaasTab from './tabs/AsaasTab';
import GenericTab from './tabs/GenericTab';

interface IntegrationFormProps {
  integration: Integration | null;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function IntegrationForm({ integration, onSubmit, isLoading, onClose }: IntegrationFormProps) {
  const [activeTab, setActiveTab] = useState('general');

  const tabs = [
    { id: 'general', label: 'Geral' },
    { id: 'ixc', label: 'IXC' },
    { id: 'whaticket', label: 'Whaticket' },
    { id: 'gammu', label: 'Gammu' },
    { id: 'digisac', label: 'Digisac' },
    { id: 'sgp', label: 'SGP' },
    { id: 'hubsoft', label: 'Hubsoft' },
    { id: 'mediawiki', label: 'MediaWiki' },
    { id: 'opa', label: 'OPA' },
    { id: 'fortics', label: 'Fortics' },
    { id: 'asaas', label: 'Asaas' },
    { id: 'generic', label: 'Genérica' },
  ];

  const tabContent = (id: string) => {
    switch (id) {
      case 'general':
        return <GeneralTab integration={integration} />;
      case 'ixc':
        return <IxcTab integration={integration} />;
      case 'whaticket':
        return <WhaticketTab integration={integration} />;
      case 'gammu':
        return <GammuTab integration={integration} />;
      case 'digisac':
        return <DigisacTab integration={integration} />;
      case 'sgp':
        return <SgpTab integration={integration} />;
      case 'hubsoft':
        return <HubsoftTab integration={integration} />;
      case 'mediawiki':
        return <MediawikiTab integration={integration} />;
      case 'opa':
        return <OpaTab integration={integration} />;
      case 'fortics':
        return <ForticsTab integration={integration} />;
      case 'asaas':
        return <AsaasTab integration={integration} />;
      case 'generic':
        return <GenericTab integration={integration} />;
      default:
        return null;
    }
  };

  return (
    <Form onSubmit={onSubmit}>
      {/* Tabs Navigation */}
      <div className="mb-6 border-b border-gray-200 dark:border-gray-700">
        <nav className="-mb-px flex flex-wrap gap-x-6 gap-y-0">
          {tabs.map(tab => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${
                  activeTab === tab.id
                    ? 'border-primary-500 text-primary-600 dark:text-primary-400'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content - all tabs stay mounted to preserve form data */}
      {tabs.map(tab => (
        <div key={tab.id} className={activeTab === tab.id ? 'block' : 'hidden'}>
          {tabContent(tab.id)}
        </div>
      ))}

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {integration ? 'Salvar' : 'Criar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default IntegrationForm;
